<template>
	<v-card flat rounded="0">
		<v-card-title primary-title>
			<v-row dense justify="space-between">
				<v-col cols="12" sm="8">
					<div
						v-if="$vuetify.breakpoint.mdAndDown"
						:class="`primary--text text-overline ml-2 ${
							$vuetify.breakpoint.xs ? 'text-center' : ''
						}`"
					>
						Resumen de propuestas diarias
					</div>
					<div
						v-else
						class="font-weight-light primary--text text-h4 ml-2 text-capitalize"
					>
						Resumen de propuestas diarias
					</div>
				</v-col>
				<v-col
					sm="4"
					cols="12"
					:class="`d-flex align-center ${
						$vuetify.breakpoint.xs
							? 'justify-center'
							: 'justify-end'
					}`"
				>
				</v-col>
			</v-row>
		</v-card-title>
		<!-- <v-divider class="test"></v-divider> -->
		<v-card-text>
			<v-data-table :headers="headers" :items="seguimientoOfertasResumen">
				<template v-slot:item.fecha="{ item }">
					{{ formatDate(item.fecha) }}
				</template>
			</v-data-table>

			<BarChart
				:chart-data="barData"
				:options="optionsBarChart"
			></BarChart>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from '@/util/libUtil.js';
import BarChart from '@/components/GerenciaTeletrabajo/Stats/BarChart.js';

export default {
	name: 'seguimientoOfertasResumen',
	data: () => ({
		optionsBarChart: {
			scales: {
				yAxes: [
					{
						stacked: true,
					},
				],
				xAxes: [
					{
						stacked: true,
					},
				],
			},
			legend: {
				display: true,
				position: 'top',
				align: 'center',
				labels: {
					padding: 10,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
		},
		headers: [
			{ text: 'Fecha', value: 'fecha' },
			{ text: 'Propuestas totales', value: 'total', align: 'center' },
			{
				text: 'Propuestas pendientes',
				value: 'pendiente',
				align: 'center',
			},
			{
				text: 'Propuestas presentadas',
				value: 'presentada',
				align: 'center',
			},
			{
				text: 'Propuestas rechazada',
				value: 'rechazada',
				align: 'center',
			},
			{ text: 'Propuestas activada', value: 'activada', align: 'center' },
			{
				text: 'Propuestas error envio a SMART',
				value: 'errorEnvioSmart',
				align: 'center',
			},
		],
	}),
	components: {
		BarChart,
	},
	methods: {
		formatDate,
	},
	computed: {
		barData(){
			let chartData = {}
			chartData.labels = []
			chartData.datasets = []

			chartData.datasets[0] = {
				type: 'bar',
				label: 'Propuestas pendiente',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.pendiente)),
				backgroundColor: "grey",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[1] = {
				type: 'bar',
				label: 'Propuestas presentada',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.presentada)),
				backgroundColor: "blue",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[2] = {
				type: 'bar',
				label: 'Propuestas rechazada',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.rechazada)),
				backgroundColor: "red",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[3] = {
				type: 'bar',
				label: 'Propuestas activada',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.activada)),
				backgroundColor: "green",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[4] = {
				type: 'bar',
				label: 'Propuestas errorEnvioSmart',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.errorEnvioSmart)),
				backgroundColor: "orange",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[5] = {
				type: 'line',
				label: 'Propuestas total',
				data: this.seguimientoOfertasResumen.map((item) => Number(item.total)),
				backgroundColor: "black",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			
			chartData.labels = this.seguimientoOfertasResumen.map((item) => formatDate(item.fecha))
			return chartData
		},
		...mapState('retailX', {
			seguimientoOfertasResumen: (state) =>
				state.seguimientoOfertasResumen,
		}),
	},
	beforeCreate() {
		//this.$store.dispatch('retailX/fetchAll');
	},
};
</script>